module.exports = __webpack_public_path__ + "static/media/address.d2534317.svg";